import { UserType } from '@nemuru-eng/js-api-client';
import { useParams } from 'react-router';

import { UserList } from '@/components/shared/components/UserList/UserList';
import { ModuleCorePermissionProps } from '@/config/types';
import { withPermissionsModule } from '@/utils/withPermissionsModule';

const AgentUserList = ({ canEdit = false }: ModuleCorePermissionProps) => {
  const { agentId } = useParams();

  if (!agentId) return null;

  return <UserList editModeAllowed={canEdit} userIds={[agentId]} userType={UserType.AGENT} />;
};

export const AgentUserListModule = withPermissionsModule(AgentUserList);
